import { render, staticRenderFns } from "./VDropdownBlock.vue?vue&type=template&id=70313e2f&scoped=true"
import script from "./VDropdownBlock.vue?vue&type=script&lang=js"
export * from "./VDropdownBlock.vue?vue&type=script&lang=js"
import style0 from "./VDropdownBlock.vue?vue&type=style&index=0&id=70313e2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70313e2f",
  null
  
)

export default component.exports